<template>
  <div class="d-flex flex-column">
    <div class="d-flex justify-space-between mb-5">
      <div class="title">
        Assinatura atual
      </div>
      <div>
        <v-btn small color="primary" @click="$emit('on-click-edit')">
          <v-icon size="20" class="mr-2">mdi-pencil-outline</v-icon>
          Editar
        </v-btn>
      </div>
    </div>
    <div class="assinatura-preview">
      <img class="assinatura mx-2" :src="assinatura" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowAssinatura',
  props: {
    assinatura: {
      required: true,
      type: String
    }
  }
}
</script>

<style>
.assinatura-preview {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  background-image: url('../../assets/fundo-png.jpg');
  background-size: contain;
  background-repeat: repeat;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  justify-items: center;
}
.title {
  color: var(--v-primary-base) !important;
  font-size: 1.1rem;
}
.assinatura {
  max-width: 90%;
}
</style>
